import { z } from "zod";

/// Boundary contract for the shore writing assistant (T3). Mirrors
/// shore src/modules/writing-assistant/ (drafts.dto.ts + surface.types.ts).
export const WRITING_ASSISTANT_SURFACES = [
  "feedback",
  "kudos",
  "todo",
  "goal",
  "goal_check_in",
  "one_on_one",
  "review",
] as const;
export type WritingAssistantSurface = (typeof WRITING_ASSISTANT_SURFACES)[number];

export const draftContextSchema = z.object({
  recipientFirstName: z.string().min(1).max(100).optional(),
  severity: z.enum(["low", "medium", "high"]).optional(),
  recipientFirstNames: z.array(z.string().min(1).max(100)).max(10).optional(),
  valueTags: z.array(z.string().min(1).max(50)).max(10).optional(),
  todoTitle: z.string().min(1).max(200).optional(),
  goalTitle: z.string().min(1).max(255).optional(),
  parentGoalTitle: z.string().min(1).max(255).optional(),
  checkInStatus: z.string().min(1).max(50).optional(),
  reviewKind: z.enum(["self", "peer", "manager"]).optional(),
  fieldLabel: z.string().min(1).max(200).optional(),
});
export type DraftContext = z.infer<typeof draftContextSchema>;

export const generateDraftRequestSchema = z.object({
  surface: z.enum(WRITING_ASSISTANT_SURFACES),
  input: z.string().min(10).max(2000),
  context: draftContextSchema.optional(),
});
export type GenerateDraftRequest = z.infer<typeof generateDraftRequestSchema>;

export const surfaceDraftSchema = z.discriminatedUnion("surface", [
  z.object({ surface: z.literal("feedback"), draft: z.object({ body: z.string() }) }),
  z.object({
    surface: z.literal("kudos"),
    draft: z.object({ title: z.string(), body: z.string() }),
  }),
  z.object({ surface: z.literal("todo"), draft: z.object({ body: z.string() }) }),
  z.object({ surface: z.literal("goal"), draft: z.object({ body: z.string() }) }),
  z.object({ surface: z.literal("goal_check_in"), draft: z.object({ body: z.string() }) }),
  z.object({ surface: z.literal("one_on_one"), draft: z.object({ body: z.string() }) }),
  z.object({ surface: z.literal("review"), draft: z.object({ body: z.string() }) }),
]);
export type SurfaceDraft = z.infer<typeof surfaceDraftSchema>;

/// Backend minimum for `input`; the button stays disabled below this.
export const ASSIST_MIN_INPUT = 10;
/// Backend maximum for `input`; longer box content is truncated client-side
/// (rough notes only need the head, a hard error would be more confusing).
export const ASSIST_MAX_INPUT = 2000;
